import { Component, OnInit } from '@angular/core';
import {AppUser} from "@data/schema/account/app-user";
import {UserData} from "@data/users";
import {NbDialogService, NbMenuItem, NbMenuService} from "@nebular/theme";
import {CognitoService} from "@services/cognito.service";
import {Router} from "@angular/router";
import {ProfileComponent} from "@layout/profile/profile.component";
import {BnNgIdleService} from "bn-ng-idle";

@Component({
  selector: 'ngx-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {
  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  user: AppUser = new AppUser();


  constructor( private menuService: NbMenuService,
              private cognitoService: CognitoService,
              private router: Router,
              private dialogService: NbDialogService,
               private bnIdle: BnNgIdleService,
  ) { }

  ngOnInit(): void {
    this.user = this.cognitoService.getAppUser();
     this.menuService.onItemClick().subscribe(item=>{
      if(item.item.title === 'Log out'){
        this.cognitoService.signOut().then((value) => {
          this.cognitoService.removeUserData();
          this.router.navigate(['/auth']);
        });


      }
      if(item.item.title === 'Profile'){
        this.dialogService.open(ProfileComponent, {
          context: {
            name: this.user.userName,
            email: this.user.email,
            mobile: '',
            profileLink: '',
          }
        });
      }
    });
   //logout automatically after 60 minutes
    this.bnIdle.startWatching(3600).subscribe(res => {
      this.cognitoService.refreshToken();
    });
  }

}
